<iho-counter [type]="'extraPerson'" [min]="1" 
[max]="(FixedGuestCount + extraPersonData)" [extraPersonData]="{}"
      (decreaseEvent)="updateNumberOfPeople('dec', $event)" (increaseEvent)="updateNumberOfPeople('inc', $event)">
      <span>
            {{(nop() > FixedGuestCount ?   FixedGuestCount : nop()) + ' نفر پایه '}}
      </span>
      &nbsp;
      <span *ngIf="nop() > FixedGuestCount">{{" + " + (nop() >FixedGuestCount ? (nop() -  FixedGuestCount) : '0') + ' نفر اضافه'}}</span>
</iho-counter>